import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * BookingTypesApi - axios parameter creator
 * @export
 */
const BookingTypesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {AvailabilitySlotToken} [AvailabilitySlotToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAvailabilitySlot: async (AvailabilitySlotToken, options = {}) => {
            const localVarPath = `/v1/BookingTypes/CreateAvailabilitySlot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(AvailabilitySlotToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {Array<AvailabilitySlotToken>} [AvailabilitySlotToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMultipleAvailabilitySlots: async (AvailabilitySlotToken, options = {}) => {
            const localVarPath = `/v1/BookingTypes/CreateMultipleAvailabilitySlots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(AvailabilitySlotToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAvailabilitySlot: async (id, options = {}) => {
            const localVarPath = `/v1/BookingTypes/DeleteAvailabilitySlot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {Array<number>} [request_body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMultipleAvailabilitySlots: async (request_body, options = {}) => {
            const localVarPath = `/v1/BookingTypes/DeleteMultipleAvailabilitySlots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(request_body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary The services a customer can book from today on: visible, and valid on the store date (T-02). (Auth roles: FrontEndUsers)
         * @param {boolean} [includeConstraints]
         * @param {String} [forDate] Ignored, kept for older storefronts: the store date decides, not the browser date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveBookingTypes: async (includeConstraints, forDate, options = {}) => {
            const localVarPath = `/v1/BookingTypes/GetActiveBookingTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (includeConstraints !== undefined) {
                localVarQueryParameter['includeConstraints'] = includeConstraints;
            }
            if (forDate !== undefined) {
                localVarQueryParameter['forDate'] = (forDate instanceof Date) ?
                    forDate.toISOString() :
                    forDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/BookingTypes/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActive: async (options = {}) => {
            const localVarPath = `/v1/BookingTypes/GetAllActive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailabilitySlots: async (bookingTypeId, options = {}) => {
            const localVarPath = `/v1/BookingTypes/GetAvailabilitySlots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (bookingTypeId !== undefined) {
                localVarQueryParameter['bookingTypeId'] = bookingTypeId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailabilitySlotsGrouped: async (bookingTypeId, options = {}) => {
            const localVarPath = `/v1/BookingTypes/GetAvailabilitySlotsGrouped`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (bookingTypeId !== undefined) {
                localVarQueryParameter['bookingTypeId'] = bookingTypeId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingStatistics: async (bookingTypeId, options = {}) => {
            const localVarPath = `/v1/BookingTypes/GetBookingStatistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (bookingTypeId !== undefined) {
                localVarQueryParameter['bookingTypeId'] = bookingTypeId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/BookingTypes/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByType: async (type, options = {}) => {
            const localVarPath = `/v1/BookingTypes/GetByType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepresentativesForBookingType: async (bookingTypeId, options = {}) => {
            const localVarPath = `/v1/BookingTypes/GetRepresentativesForBookingType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (bookingTypeId !== undefined) {
                localVarQueryParameter['bookingTypeId'] = bookingTypeId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRules: async (id, options = {}) => {
            const localVarPath = `/v1/BookingTypes/GetRules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingTypeToken} [BookingTypeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (BookingTypeToken, options = {}) => {
            const localVarPath = `/v1/BookingTypes/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(BookingTypeToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/BookingTypes/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {any} [body]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRules: async (body, id, options = {}) => {
            const localVarPath = `/v1/BookingTypes/SaveRules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {string} [searchText]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (searchText, options = {}) => {
            const localVarPath = `/v1/BookingTypes/Search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingTypeToken} [BookingTypeToken]
         * @param {boolean} [cancelAffected]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (BookingTypeToken, cancelAffected, options = {}) => {
            const localVarPath = `/v1/BookingTypes/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (cancelAffected !== undefined) {
                localVarQueryParameter['cancelAffected'] = cancelAffected;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(BookingTypeToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {AvailabilitySlotToken} [AvailabilitySlotToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvailabilitySlot: async (AvailabilitySlotToken, options = {}) => {
            const localVarPath = `/v1/BookingTypes/UpdateAvailabilitySlot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(AvailabilitySlotToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {AvailabilitySlotUpdateToken} [AvailabilitySlotUpdateToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvailabilitySlotPartial: async (AvailabilitySlotUpdateToken, options = {}) => {
            const localVarPath = `/v1/BookingTypes/UpdateAvailabilitySlotPartial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(AvailabilitySlotUpdateToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BookingTypesApi - functional programming interface
 * @export
 */
const BookingTypesApiFp = function (configuration) {
    const localVarAxiosParamCreator = BookingTypesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {AvailabilitySlotToken} [AvailabilitySlotToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAvailabilitySlot(AvailabilitySlotToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAvailabilitySlot(AvailabilitySlotToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingTypesApi.createAvailabilitySlot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {Array<AvailabilitySlotToken>} [AvailabilitySlotToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMultipleAvailabilitySlots(AvailabilitySlotToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMultipleAvailabilitySlots(AvailabilitySlotToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingTypesApi.createMultipleAvailabilitySlots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAvailabilitySlot(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAvailabilitySlot(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingTypesApi.deleteAvailabilitySlot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {Array<number>} [request_body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMultipleAvailabilitySlots(request_body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMultipleAvailabilitySlots(request_body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingTypesApi.deleteMultipleAvailabilitySlots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary The services a customer can book from today on: visible, and valid on the store date (T-02). (Auth roles: FrontEndUsers)
         * @param {boolean} [includeConstraints]
         * @param {String} [forDate] Ignored, kept for older storefronts: the store date decides, not the browser date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveBookingTypes(includeConstraints, forDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveBookingTypes(includeConstraints, forDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingTypesApi.getActiveBookingTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingTypesApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllActive(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllActive(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingTypesApi.getAllActive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailabilitySlots(bookingTypeId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailabilitySlots(bookingTypeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingTypesApi.getAvailabilitySlots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailabilitySlotsGrouped(bookingTypeId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailabilitySlotsGrouped(bookingTypeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingTypesApi.getAvailabilitySlotsGrouped']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingStatistics(bookingTypeId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingStatistics(bookingTypeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingTypesApi.getBookingStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingTypesApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByType(type, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByType(type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingTypesApi.getByType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRepresentativesForBookingType(bookingTypeId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRepresentativesForBookingType(bookingTypeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingTypesApi.getRepresentativesForBookingType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRules(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRules(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingTypesApi.getRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingTypeToken} [BookingTypeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(BookingTypeToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(BookingTypeToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingTypesApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingTypesApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {any} [body]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveRules(body, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveRules(body, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingTypesApi.saveRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {string} [searchText]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(searchText, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(searchText, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingTypesApi.search']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingTypeToken} [BookingTypeToken]
         * @param {boolean} [cancelAffected]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(BookingTypeToken, cancelAffected, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(BookingTypeToken, cancelAffected, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingTypesApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {AvailabilitySlotToken} [AvailabilitySlotToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAvailabilitySlot(AvailabilitySlotToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAvailabilitySlot(AvailabilitySlotToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingTypesApi.updateAvailabilitySlot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {AvailabilitySlotUpdateToken} [AvailabilitySlotUpdateToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAvailabilitySlotPartial(AvailabilitySlotUpdateToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAvailabilitySlotPartial(AvailabilitySlotUpdateToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingTypesApi.updateAvailabilitySlotPartial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * BookingTypesApi - factory interface
 * @export
 */
const BookingTypesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BookingTypesApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {AvailabilitySlotToken} [AvailabilitySlotToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAvailabilitySlot(AvailabilitySlotToken, options) {
            return localVarFp.createAvailabilitySlot(AvailabilitySlotToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {Array<AvailabilitySlotToken>} [AvailabilitySlotToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMultipleAvailabilitySlots(AvailabilitySlotToken, options) {
            return localVarFp.createMultipleAvailabilitySlots(AvailabilitySlotToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAvailabilitySlot(id, options) {
            return localVarFp.deleteAvailabilitySlot(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {Array<number>} [request_body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMultipleAvailabilitySlots(request_body, options) {
            return localVarFp.deleteMultipleAvailabilitySlots(request_body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary The services a customer can book from today on: visible, and valid on the store date (T-02). (Auth roles: FrontEndUsers)
         * @param {boolean} [includeConstraints]
         * @param {String} [forDate] Ignored, kept for older storefronts: the store date decides, not the browser date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveBookingTypes(includeConstraints, forDate, options) {
            return localVarFp.getActiveBookingTypes(includeConstraints, forDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActive(options) {
            return localVarFp.getAllActive(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailabilitySlots(bookingTypeId, options) {
            return localVarFp.getAvailabilitySlots(bookingTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailabilitySlotsGrouped(bookingTypeId, options) {
            return localVarFp.getAvailabilitySlotsGrouped(bookingTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingStatistics(bookingTypeId, options) {
            return localVarFp.getBookingStatistics(bookingTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByType(type, options) {
            return localVarFp.getByType(type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepresentativesForBookingType(bookingTypeId, options) {
            return localVarFp.getRepresentativesForBookingType(bookingTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRules(id, options) {
            return localVarFp.getRules(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingTypeToken} [BookingTypeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(BookingTypeToken, options) {
            return localVarFp.insert(BookingTypeToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {any} [body]
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRules(body, id, options) {
            return localVarFp.saveRules(body, id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {string} [searchText]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(searchText, options) {
            return localVarFp.search(searchText, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingTypeToken} [BookingTypeToken]
         * @param {boolean} [cancelAffected]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(BookingTypeToken, cancelAffected, options) {
            return localVarFp.update(BookingTypeToken, cancelAffected, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {AvailabilitySlotToken} [AvailabilitySlotToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvailabilitySlot(AvailabilitySlotToken, options) {
            return localVarFp.updateAvailabilitySlot(AvailabilitySlotToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {AvailabilitySlotUpdateToken} [AvailabilitySlotUpdateToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvailabilitySlotPartial(AvailabilitySlotUpdateToken, options) {
            return localVarFp.updateAvailabilitySlotPartial(AvailabilitySlotUpdateToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BookingTypesApi - object-oriented interface
 * @export
 * @class BookingTypesApi
 * @extends {BaseAPI}
 */
class BookingTypesApi extends BaseAPI {
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {AvailabilitySlotToken} [AvailabilitySlotToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTypesApi
     */
    createAvailabilitySlot(AvailabilitySlotToken, options) {
        return BookingTypesApiFp(this.configuration).createAvailabilitySlot(AvailabilitySlotToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {Array<AvailabilitySlotToken>} [AvailabilitySlotToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTypesApi
     */
    createMultipleAvailabilitySlots(AvailabilitySlotToken, options) {
        return BookingTypesApiFp(this.configuration).createMultipleAvailabilitySlots(AvailabilitySlotToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTypesApi
     */
    deleteAvailabilitySlot(id, options) {
        return BookingTypesApiFp(this.configuration).deleteAvailabilitySlot(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {Array<number>} [request_body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTypesApi
     */
    deleteMultipleAvailabilitySlots(request_body, options) {
        return BookingTypesApiFp(this.configuration).deleteMultipleAvailabilitySlots(request_body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary The services a customer can book from today on: visible, and valid on the store date (T-02). (Auth roles: FrontEndUsers)
     * @param {boolean} [includeConstraints]
     * @param {String} [forDate] Ignored, kept for older storefronts: the store date decides, not the browser date.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTypesApi
     */
    getActiveBookingTypes(includeConstraints, forDate, options) {
        return BookingTypesApiFp(this.configuration).getActiveBookingTypes(includeConstraints, forDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTypesApi
     */
    getAll(options) {
        return BookingTypesApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTypesApi
     */
    getAllActive(options) {
        return BookingTypesApiFp(this.configuration).getAllActive(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [bookingTypeId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTypesApi
     */
    getAvailabilitySlots(bookingTypeId, options) {
        return BookingTypesApiFp(this.configuration).getAvailabilitySlots(bookingTypeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [bookingTypeId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTypesApi
     */
    getAvailabilitySlotsGrouped(bookingTypeId, options) {
        return BookingTypesApiFp(this.configuration).getAvailabilitySlotsGrouped(bookingTypeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [bookingTypeId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTypesApi
     */
    getBookingStatistics(bookingTypeId, options) {
        return BookingTypesApiFp(this.configuration).getBookingStatistics(bookingTypeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTypesApi
     */
    getById(id, options) {
        return BookingTypesApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTypesApi
     */
    getByType(type, options) {
        return BookingTypesApiFp(this.configuration).getByType(type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [bookingTypeId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTypesApi
     */
    getRepresentativesForBookingType(bookingTypeId, options) {
        return BookingTypesApiFp(this.configuration).getRepresentativesForBookingType(bookingTypeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTypesApi
     */
    getRules(id, options) {
        return BookingTypesApiFp(this.configuration).getRules(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {BookingTypeToken} [BookingTypeToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTypesApi
     */
    insert(BookingTypeToken, options) {
        return BookingTypesApiFp(this.configuration).insert(BookingTypeToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTypesApi
     */
    remove(id, options) {
        return BookingTypesApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {any} [body]
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTypesApi
     */
    saveRules(body, id, options) {
        return BookingTypesApiFp(this.configuration).saveRules(body, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {string} [searchText]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTypesApi
     */
    search(searchText, options) {
        return BookingTypesApiFp(this.configuration).search(searchText, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {BookingTypeToken} [BookingTypeToken]
     * @param {boolean} [cancelAffected]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTypesApi
     */
    update(BookingTypeToken, cancelAffected, options) {
        return BookingTypesApiFp(this.configuration).update(BookingTypeToken, cancelAffected, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {AvailabilitySlotToken} [AvailabilitySlotToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTypesApi
     */
    updateAvailabilitySlot(AvailabilitySlotToken, options) {
        return BookingTypesApiFp(this.configuration).updateAvailabilitySlot(AvailabilitySlotToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {AvailabilitySlotUpdateToken} [AvailabilitySlotUpdateToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingTypesApi
     */
    updateAvailabilitySlotPartial(AvailabilitySlotUpdateToken, options) {
        return BookingTypesApiFp(this.configuration).updateAvailabilitySlotPartial(AvailabilitySlotUpdateToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { BookingTypesApi, BookingTypesApiAxiosParamCreator, BookingTypesApiFactory, BookingTypesApiFp };
//# sourceMappingURL=booking-types-api.js.map
